var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReuser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3423_1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3571 13.9231C12.5483 13.4295 12.2581 13.4792 12.2581 12.493C12.2581 12.1478 12.2581 11.5064 12.2581 10.9147C12.7021 10.4218 12.8635 10.4831 13.2389 8.54766C13.998 8.54766 13.9488 7.56141 14.3069 6.68657C14.5987 5.97414 14.3542 5.68532 14.1084 5.56727C14.3094 2.9711 14.3094 1.18305 11.3626 0.628363C10.2945 -0.287145 8.68275 0.0236754 7.91897 0.176449C7.15584 0.329222 6.46744 0.176449 6.46744 0.176449L6.59854 1.40653C5.48104 2.74762 6.03986 4.53567 5.85994 5.58293C5.62549 5.71067 5.414 6.00516 5.69318 6.68657C6.05119 7.56141 6.00201 8.54766 6.76115 8.54766C7.13654 10.4831 7.29795 10.4218 7.7419 10.9147C7.7419 11.5064 7.7419 12.1478 7.7419 12.493C7.7419 13.4792 7.4067 13.4962 6.64295 13.9231C4.80154 14.9524 2.40197 15.5504 1.97205 18.7673C1.8933 19.3556 5.27158 19.998 10 20C14.7285 19.998 18.1066 19.3556 18.028 18.7673C17.5981 15.5504 15.1765 15.0331 13.3571 13.9231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3423_1397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReuser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reuser.796b16e9.svg";
export { ForwardRef as ReactComponent };